import { render, staticRenderFns } from "./FormAttachments.vue?vue&type=template&id=ae2b2498"
import script from "./FormAttachments.vue?vue&type=script&lang=js"
export * from "./FormAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports